/**
 * VelocityCard — improvement velocity inline display.
 *
 * Extracted from AthleteDashboard.tsx (Feature 5 / Phase D).
 * Exposes the `slope`, `velocityLabel` helpers and the `VelocityDisplay`
 * inline component (renders the velocity text + icon row).
 *
 * Pure mechanical extraction — same interface and behavior as inline code.
 */

import {
  ArrowTrendingUpIcon,
  MinusCircleIcon,
} from '@heroicons/react/24/outline';

// ─── VelocityDisplay component ────────────────────────────────────────────────

export interface VelocityDisplayProps {
  velocity: { text: string; positive: boolean };
}

/**
 * Renders the velocity text row (icon + text).
 * Extracted from AthleteDashboard's inline `{velocity && (...)}` block.
 */
export function VelocityDisplay({ velocity }: VelocityDisplayProps) {
  return (
    <p
      style={{
        fontSize: '13px',
        color: velocity.positive ? 'var(--color-accent)' : 'var(--color-text-muted)',
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
      }}
    >
      {velocity.positive ? (
        <ArrowTrendingUpIcon style={{ width: '15px', height: '15px', flexShrink: 0 }} />
      ) : (
        <MinusCircleIcon style={{ width: '15px', height: '15px', flexShrink: 0 }} />
      )}
      {velocity.text}
    </p>
  );
}

export default VelocityDisplay;
